<template>
  <header class="site_header">
    <nav class="menu">
      <div class="inner container">
        <div class="logo">
          <a href="/"
            ><img
              :src="
                parsedGlobalSettings.general.logo
                  ? parsedGlobalSettings.general.logo
                  : logo
              "
              alt="Diesel Cleaning Solutions"
            />
          </a>
        </div>

        <div class="right">
          <ul v-if="window.width > 1240">
            <menu-item
              v-for="(menu_item, index) in parsedMenu"
              :key="index"
              :menu_item="menu_item"
              :has-children="menu_item.children ? true : false"
              :selected="menu_item.object_id == currentId"
              :last="index + 1 === parsedMenu.length"
            ></menu-item>
          </ul>

          <div class="ctas">
            <primary-button
              v-if="parsedGlobalSettings.general.cta && window.width > 600"
              :link="parsedGlobalSettings.general.cta"
              :label="parsedGlobalSettings.general.cta.title"
              :theme="'yellow'"
              :target="parsedGlobalSettings.general.cta.target"
            ></primary-button>
            <div class="phone-icon" v-if="window.width <= 600">
              <svg
                width="21"
                height="19"
                viewBox="0 0 21 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.325 12.9646L5.85786 12.5001L6.9426 11.4092L7.40964 11.8737L6.325 12.9646ZM4.28915 12.3056L2.3298 13.3707L1.59509 12.0192L3.55443 10.9541L4.28915 12.3056ZM1.9526 15.4877L3.40952 16.9363L2.32488 18.0272L0.867958 16.5786L1.9526 15.4877ZM4.29725 17.4028C5.78422 17.5413 9.63133 17.4178 13.7966 13.2762L14.8813 14.3671C10.3359 18.8866 6.00974 19.1074 4.15449 18.9344L4.29725 17.4028ZM13.7966 13.2762C17.7669 9.32836 18.4246 6.00793 18.5065 4.56742L20.0424 4.6547C19.9393 6.46773 19.125 10.1475 14.8813 14.3671L13.7966 13.2762ZM12.3861 6.93787L12.092 6.64539L13.1766 5.55453L13.4708 5.847L12.3861 6.93787ZM11.8578 2.91724L13.151 1.18977L14.3825 2.1117L13.0893 3.83917L11.8578 2.91724ZM17.5005 0.813781L19.1102 2.41437L18.0255 3.50525L16.4158 1.90466L17.5005 0.813781ZM12.9284 6.39244C13.4708 5.847 13.4715 5.84773 13.4722 5.84847C13.4725 5.84871 13.4732 5.84946 13.4737 5.84996C13.4747 5.85098 13.4758 5.852 13.4768 5.85306C13.4789 5.85518 13.481 5.85739 13.4832 5.85969C13.4877 5.86429 13.4924 5.86927 13.4973 5.87465C13.5072 5.88539 13.5181 5.89767 13.5297 5.91155C13.553 5.93929 13.5793 5.97345 13.607 6.01432C13.6625 6.09625 13.723 6.20458 13.7743 6.34082C13.8791 6.6188 13.9352 6.98525 13.8648 7.43901C13.7271 8.32641 13.116 9.4986 11.5505 11.0552L10.4658 9.96431C11.9309 8.50759 12.2799 7.62109 12.3447 7.20317C12.3755 7.00428 12.3435 6.90639 12.3347 6.88321C12.3294 6.86887 12.3268 6.86741 12.3334 6.8772C12.3367 6.88199 12.3421 6.88949 12.3506 6.89959C12.3548 6.90465 12.3599 6.91037 12.3657 6.91675C12.3687 6.91994 12.3717 6.92329 12.3752 6.92681C12.3769 6.92857 12.3786 6.93037 12.3805 6.93221C12.3814 6.93314 12.3823 6.93407 12.3832 6.93501C12.3836 6.93548 12.3844 6.9362 12.3847 6.93644C12.3854 6.93716 12.3861 6.93787 12.9284 6.39244ZM11.5505 11.0552C9.98443 12.6123 8.80677 13.2183 7.91791 13.3547C7.46369 13.4244 7.09746 13.3688 6.81963 13.2653C6.68344 13.2145 6.57493 13.1548 6.49289 13.0998C6.45187 13.0723 6.41761 13.0461 6.38982 13.0231C6.37587 13.0116 6.36356 13.0008 6.3528 12.991C6.34736 12.986 6.34234 12.9814 6.33772 12.977C6.33536 12.9748 6.33321 12.9726 6.33105 12.9706C6.33003 12.9695 6.329 12.9685 6.32798 12.9675C6.32746 12.967 6.32664 12.9663 6.32644 12.966C6.32572 12.9653 6.325 12.9646 6.86732 12.4191C7.40964 11.8737 7.40893 11.873 7.40821 11.8723C7.408 11.8721 7.40728 11.8714 7.40677 11.8708C7.40585 11.8699 7.40493 11.869 7.404 11.8681C7.40205 11.8663 7.40031 11.8646 7.39857 11.8628C7.39498 11.8595 7.39159 11.8564 7.38841 11.8534C7.38206 11.8477 7.37631 11.8426 7.37118 11.8385C7.36113 11.8301 7.35365 11.8248 7.34903 11.8216C7.33949 11.8153 7.34144 11.8181 7.35662 11.8238C7.38175 11.8331 7.48236 11.8652 7.6846 11.8341C8.10847 11.7692 9.00122 11.4205 10.4658 9.96431L11.5505 11.0552ZM13.151 1.18977C14.1964 -0.206628 16.252 -0.427587 17.5005 0.813781L16.4158 1.90466C15.8705 1.36247 14.9021 1.41766 14.3825 2.1117L13.151 1.18977ZM18.5065 4.56742C18.5267 4.21246 18.3639 3.84168 18.0255 3.50525L19.1102 2.41437C19.6613 2.9623 20.0945 3.73794 20.0424 4.6547L18.5065 4.56742ZM3.40952 16.9363C3.69135 17.2166 3.99348 17.3744 4.29725 17.4028L4.15449 18.9344C3.40111 18.8642 2.78382 18.4836 2.32488 18.0272L3.40952 16.9363ZM12.092 6.64539C11.0823 5.64144 11.0072 4.05346 11.8578 2.91724L13.0893 3.83917C12.6755 4.39193 12.7371 5.11746 13.1766 5.55453L12.092 6.64539ZM2.3298 13.3707C1.49109 13.8267 1.36044 14.8988 1.9526 15.4877L0.867958 16.5786C-0.506609 15.2118 -0.082743 12.9313 1.59509 12.0192L2.3298 13.3707ZM5.85786 12.5001C5.46404 12.1086 4.83014 12.0116 4.28915 12.3056L3.55443 10.9541C4.66574 10.3499 6.04492 10.5168 6.9426 11.4092L5.85786 12.5001Z"
                  fill="#0F0020"
                />
              </svg>
            </div>
          </div>

          <menu-button
            v-if="window.width <= 1240"
            @click.native="toggleMobileMenu()"
            :label="this.$store.state.mobile_menu ? 'Close' : 'Menu'"
            :type="this.$store.state.mobile_menu ? 'close' : 'open'"
          ></menu-button>
        </div>
      </div>
    </nav>

    <search-bar
      :toggle_search="showSearch"
      @close_search="showSearch = !showSearch"
    ></search-bar>

    <transition name="bounce">
      <nav class="menu scrolled" v-if="isScrolled">
        <div class="container">
          <div class="inner">
            <div class="logo">
              <a href="/"
                ><img
                  :src="
                    parsedGlobalSettings.general.logo
                      ? parsedGlobalSettings.general.logo
                      : logo
                  "
                  alt="Diesel Cleaning Solutions"
                />
              </a>
            </div>

            <div class="right">
              <ul v-if="window.width > 1240">
                <menu-item
                  v-for="(menu_item, index) in parsedMenu"
                  :key="index"
                  :menu_item="menu_item"
                  :has-children="menu_item.children ? true : false"
                  :selected="menu_item.object_id == currentId"
                  :last="index + 1 === parsedMenu.length"
                ></menu-item>
              </ul>

              <div class="ctas">
                <primary-button
                  v-if="parsedGlobalSettings.general.cta && window.width > 600"
                  :link="parsedGlobalSettings.general.cta"
                  :label="parsedGlobalSettings.general.cta.title"
                  :theme="'yellow'"
                  :target="parsedGlobalSettings.general.cta.target"
                ></primary-button>
                <div
                  class="phone-icon"
                  v-if="parsedGlobalSettings.general.cta && window.width <= 600"
                >
                  <svg
                    width="21"
                    height="19"
                    viewBox="0 0 21 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.325 12.9646L5.85786 12.5001L6.9426 11.4092L7.40964 11.8737L6.325 12.9646ZM4.28915 12.3056L2.3298 13.3707L1.59509 12.0192L3.55443 10.9541L4.28915 12.3056ZM1.9526 15.4877L3.40952 16.9363L2.32488 18.0272L0.867958 16.5786L1.9526 15.4877ZM4.29725 17.4028C5.78422 17.5413 9.63133 17.4178 13.7966 13.2762L14.8813 14.3671C10.3359 18.8866 6.00974 19.1074 4.15449 18.9344L4.29725 17.4028ZM13.7966 13.2762C17.7669 9.32836 18.4246 6.00793 18.5065 4.56742L20.0424 4.6547C19.9393 6.46773 19.125 10.1475 14.8813 14.3671L13.7966 13.2762ZM12.3861 6.93787L12.092 6.64539L13.1766 5.55453L13.4708 5.847L12.3861 6.93787ZM11.8578 2.91724L13.151 1.18977L14.3825 2.1117L13.0893 3.83917L11.8578 2.91724ZM17.5005 0.813781L19.1102 2.41437L18.0255 3.50525L16.4158 1.90466L17.5005 0.813781ZM12.9284 6.39244C13.4708 5.847 13.4715 5.84773 13.4722 5.84847C13.4725 5.84871 13.4732 5.84946 13.4737 5.84996C13.4747 5.85098 13.4758 5.852 13.4768 5.85306C13.4789 5.85518 13.481 5.85739 13.4832 5.85969C13.4877 5.86429 13.4924 5.86927 13.4973 5.87465C13.5072 5.88539 13.5181 5.89767 13.5297 5.91155C13.553 5.93929 13.5793 5.97345 13.607 6.01432C13.6625 6.09625 13.723 6.20458 13.7743 6.34082C13.8791 6.6188 13.9352 6.98525 13.8648 7.43901C13.7271 8.32641 13.116 9.4986 11.5505 11.0552L10.4658 9.96431C11.9309 8.50759 12.2799 7.62109 12.3447 7.20317C12.3755 7.00428 12.3435 6.90639 12.3347 6.88321C12.3294 6.86887 12.3268 6.86741 12.3334 6.8772C12.3367 6.88199 12.3421 6.88949 12.3506 6.89959C12.3548 6.90465 12.3599 6.91037 12.3657 6.91675C12.3687 6.91994 12.3717 6.92329 12.3752 6.92681C12.3769 6.92857 12.3786 6.93037 12.3805 6.93221C12.3814 6.93314 12.3823 6.93407 12.3832 6.93501C12.3836 6.93548 12.3844 6.9362 12.3847 6.93644C12.3854 6.93716 12.3861 6.93787 12.9284 6.39244ZM11.5505 11.0552C9.98443 12.6123 8.80677 13.2183 7.91791 13.3547C7.46369 13.4244 7.09746 13.3688 6.81963 13.2653C6.68344 13.2145 6.57493 13.1548 6.49289 13.0998C6.45187 13.0723 6.41761 13.0461 6.38982 13.0231C6.37587 13.0116 6.36356 13.0008 6.3528 12.991C6.34736 12.986 6.34234 12.9814 6.33772 12.977C6.33536 12.9748 6.33321 12.9726 6.33105 12.9706C6.33003 12.9695 6.329 12.9685 6.32798 12.9675C6.32746 12.967 6.32664 12.9663 6.32644 12.966C6.32572 12.9653 6.325 12.9646 6.86732 12.4191C7.40964 11.8737 7.40893 11.873 7.40821 11.8723C7.408 11.8721 7.40728 11.8714 7.40677 11.8708C7.40585 11.8699 7.40493 11.869 7.404 11.8681C7.40205 11.8663 7.40031 11.8646 7.39857 11.8628C7.39498 11.8595 7.39159 11.8564 7.38841 11.8534C7.38206 11.8477 7.37631 11.8426 7.37118 11.8385C7.36113 11.8301 7.35365 11.8248 7.34903 11.8216C7.33949 11.8153 7.34144 11.8181 7.35662 11.8238C7.38175 11.8331 7.48236 11.8652 7.6846 11.8341C8.10847 11.7692 9.00122 11.4205 10.4658 9.96431L11.5505 11.0552ZM13.151 1.18977C14.1964 -0.206628 16.252 -0.427587 17.5005 0.813781L16.4158 1.90466C15.8705 1.36247 14.9021 1.41766 14.3825 2.1117L13.151 1.18977ZM18.5065 4.56742C18.5267 4.21246 18.3639 3.84168 18.0255 3.50525L19.1102 2.41437C19.6613 2.9623 20.0945 3.73794 20.0424 4.6547L18.5065 4.56742ZM3.40952 16.9363C3.69135 17.2166 3.99348 17.3744 4.29725 17.4028L4.15449 18.9344C3.40111 18.8642 2.78382 18.4836 2.32488 18.0272L3.40952 16.9363ZM12.092 6.64539C11.0823 5.64144 11.0072 4.05346 11.8578 2.91724L13.0893 3.83917C12.6755 4.39193 12.7371 5.11746 13.1766 5.55453L12.092 6.64539ZM2.3298 13.3707C1.49109 13.8267 1.36044 14.8988 1.9526 15.4877L0.867958 16.5786C-0.506609 15.2118 -0.082743 12.9313 1.59509 12.0192L2.3298 13.3707ZM5.85786 12.5001C5.46404 12.1086 4.83014 12.0116 4.28915 12.3056L3.55443 10.9541C4.66574 10.3499 6.04492 10.5168 6.9426 11.4092L5.85786 12.5001Z"
                      fill="#0F0020"
                    />
                  </svg>
                </div>
              </div>

              <menu-button
                v-if="window.width <= 1240"
                @click.native="toggleMobileMenu()"
                :label="this.$store.state.mobile_menu ? 'Close' : 'Menu'"
                :type="this.$store.state.mobile_menu ? 'close' : 'open'"
              ></menu-button>
            </div>
          </div>
        </div>
      </nav>
    </transition>

    <mobile-menu
      :is-showing="this.$store.state.mobile_menu"
      :current-id="currentId"
      :menu-data="parsedMenu"
      :mobile-sub-nav="parsedMobileSubNavMenu"
      :class="{ alert_open: this.$store.state.alert_bar_closed === false }"
    >
    </mobile-menu>

    <transition name="fade">
      <div
        class="modal mobile"
        @click="closeAll()"
        v-if="(mobileMenu && window.width <= 1240) || showSearch"
      ></div>
    </transition>
  </header>
</template>

<script>
import MenuItem from '../vue/MenuItem.vue';
import MenuButton from '../vue/MenuButton.vue';
import PrimaryButton from '../vue/PrimaryButton.vue';
import MobileMenu from '../vue/MobileMenu.vue';

export default {
  data() {
    return {
      showSearch: false,
      topScrollThreshold: 100,
      topScrollThresholdMob: 50,
      isScrolled: false,
      isMobScrolled: false,
      window: {
        width: 0,
        height: 0,
      },
    };
  },

  props: {
    logo: {},
    currentId: {
      type: Number,
      default: -1,
    },
    global_settings: {},
    menu: {},
    top_left_nav: {},
    top_right_nav: {},
    mobile_sub_nav: {},
    toggle_alert_banner: {},
    alert_banner_text: {},
    alert_banner_link: {},
    alert_banner_id: {},
  },

  computed: {
    parsedGlobalSettings() {
      if (this.global_settings) {
        return JSON.parse(this.global_settings);
      } else {
        return null;
      }
    },

    mobileMenu() {
      return this.$store.state.mobile_menu
        ? this.$store.state.mobile_menu
        : false;
    },

    parsedMenu() {
      if (this.menu) {
        return JSON.parse(this.menu);
      } else {
        return null;
      }
    },

    parsedTopLeft() {
      if (this.top_left_nav) {
        return JSON.parse(this.top_left_nav);
      } else {
        return null;
      }
    },

    parsedTopRight() {
      if (this.top_right_nav) {
        return JSON.parse(this.top_right_nav);
      } else {
        return null;
      }
    },

    parsedMobileSubNavMenu() {
      if (this.mobile_sub_nav) {
        return JSON.parse(this.mobile_sub_nav);
      } else {
        return null;
      }
    },
  },

  watch: {},

  methods: {
    didScroll() {
      var elementTarget = document.querySelector('.site_header');
      this.isScrolled = window.scrollY > elementTarget.offsetHeight + 100;
      this.updateTrigger();
    },

    mobDidScroll() {
      // var elementTarget = document.querySelector('.site_header');
      this.isMobScrolled = window.scrollY > 0;
      this.updateTrigger();
      this.closeAll();
    },

    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      this.closeAll();
      this.updateTrigger();
      this.moveTranslate('.translation_desktop');
      this.moveTranslate('.translation_scrolled');
    },

    toggleMobileMenu(arg) {
      this.$store.commit(
        'toggleMobileMenu',
        arg ? arg : !this.$store.state.mobile_menu,
      );
    },

    async closeAll() {
      this.$store.commit('toggleMobileMenu', false);
    },

    capitalizeWords(arr) {
      return arr.map((element) => {
        return element.charAt(0).toUpperCase() + element.slice(1).toLowerCase();
      });
    },

    updateTrigger() {
      var sideNav = document.querySelector('.page-template-template-side_nav');
      var hash = window.location.hash;
      let navAccordion = document.querySelectorAll('.anchored_nav_accordion');

      if (hash && sideNav && navAccordion) {
        navAccordion.forEach((element) => {
          var accordion_trigger = element.querySelector(
            '.accordion__trigger label',
          );
          var accordion_content = element.querySelectorAll(
            '.accordion__content ul li',
          );
          let newHash = hash.replace('#', '').replace('_', ' ');
          if (accordion_trigger) {
            accordion_trigger.innerHTML = newHash.replace(
              /(^\w{1})|(\s+\w{1})/g,
              (letter) => letter.toUpperCase(),
            );
          }

          if (accordion_content) {
            accordion_content.forEach((element) => {
              let theLink = element.querySelector('a');

              if (theLink.href.split('#')[1] === hash.replace('#', '')) {
                element.classList.add('current');
              } else {
                element.classList.remove('current');
              }
            });
          }
        });
      }
    },

    moveTranslate(arg) {
      // Find the reference element
      const referenceElement = document.querySelector(arg);

      if (referenceElement) {
        // Get the position of the reference element relative to the viewport
        const referenceRect = referenceElement.getBoundingClientRect();

        // Find the target element
        const targetElement = document.querySelector('.gtranslate_wrapper');

        // Set the position of the target element to be absolute

        if (this.window.width > 1240) {
          targetElement.style.position = 'absolute';
          targetElement.style.transition = 'unset';

          // Set the top and left CSS properties of the target element based on the position of the reference element
          targetElement.style.top = 1 + 'px';
          targetElement.style.left =
            referenceRect.left + window.pageXOffset + 'px';
        }
      }
    },
  },

  components: {
    MenuItem,
    MenuButton,
    // SmallSearchBar,
    // SearchButton,
    MobileMenu,
    PrimaryButton,
  },

  created() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('load', this.handleResize);
    window.dispatchEvent(new Event('resize'));
    window.addEventListener('scroll', this.didScroll);
    window.addEventListener('scroll', this.mobDidScroll);
    this.handleResize();
    this.$store.commit('toggleMobileMenu', false);
  },

  destroyed() {
    window.removeEventListener('scroll', this.didScroll);
    window.removeEventListener('scroll', this.mobDidScroll);
    window.removeEventListener('resize', this.handleResize);
    this.handleResize();
  },

  mounted() {
    window.dispatchEvent(new Event('resize'));
    this.handleResize();
  },

  change() {
    window.dispatchEvent(new Event('resize'));
    this.handleResize();
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.site_header {
  position: relative;
  width: 100%;
  z-index: 100;
  border-bottom: 2px solid var(--purple);

  .modal {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(#000000, 0.3);
    z-index: 50;
  }

  /* .top_menu {
		background: var(--green);
		position: relative;
		z-index: 110;

		.container {
			width: 100%;

			.inner {
				grid-column: span 12;
				display: flex;
				justify-content: space-between;

				ul {
					list-style: none;
					display: flex;
					padding: 0;
					margin: 8px 0;

					li {


						&::v-deep {
							a {
								color: var(--dark-purple);

								&::before {
									display: none;
								}

								&:hover {
									color: var(--dark-purple);
								}
							}

							&:first-of-type {
								> .parent_container {
									padding-left: 0;

									@media (max-width: $tablet) {
										padding-left: 20px;
									}
								}

								> .menu__child {
									left: 0;
								}
							}

							&:last-of-type {
								> .parent_container {
									padding-right: 0;
								}
							}
						}
					}

					&.menu__child {
						li {
							&::v-deep {
								a {
									&:hover {
										color: white;
									}
								}
							}
						}
					}
				}

				.search_extra {
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding: 0;
					gap: 32px;
				}

				&.mob {
					grid-column: span 4;
					display: flex;
					flex-direction: row;
					gap: 35x;
					padding: 15px 0 10px;
					justify-content: flex-end;
					align-items: center;

					@media (max-width: $mobile-xl) {
						grid-template-columns: auto auto auto;
						gap: 35px;
					}

					.search_button {
						grid-column: span 1;
						justify-content: center;
					}

					.menu_item__parent {
						a {
							&::v-deep {
								&.menu_item__parent__primary_link.top::before {
									display: none;
								}
							}
						}
					}
				}
			}
		}
	} */

  .menu {
    position: relative;
    z-index: 100;
    background-color: var(--dark-purple);

    &.scrolled {
      position: fixed;
      top: 0;
      z-index: 120;
      width: 100%;
      border-top: 0;
      background: var(--dark-purple);

      @media (min-width: $mobile-xl) {
        border-bottom: 2px solid var(--purple);
      }

      @media (max-width: $mobile-xl) {
        background: transparent;

        .logo,
        .ctas {
          visibility: hidden;
          opacity: 0;
        }

        .site_button {
          margin: 10px 0;
          border-radius: 15px;
          padding: 10px 16px;
        }
      }
    }

    .inner {
      grid-column: span 12;
      display: grid;
      grid-template-columns: 1fr auto;
      column-gap: 24px;
      // margin: 0 auto;
      padding: 12px var(--gutter-tablet-desktop);
      align-items: center;
      /* max-width: var(--max-width); */

      .scrolled & {
        padding: 12px 0;
      }

      @media (max-width: $tablet) {
        // margin: 0 auto;
        grid-column: span 4;
        padding: 0 0;
      }

      @media (max-width: $mobile-xl) {
        padding: 0 0;
        // padding: 0 10px 0 16px;
      }
    }

    .logo {
      grid-column: span 1;
      display: flex;

      a {
        display: flex;
      }

      img {
        height: 50px;

        @media (max-width: $tablet) {
          height: 40px;
          padding: 4px 0;
        }
      }
    }

    .right {
      grid-column: span 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 30px;

      @media (max-width: $tablet) {
        gap: 15px;
      }
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: row;
      column-gap: 0;
      justify-content: center;
      align-items: center;
      grid-column: span 1;

      li {
        a {
          color: white;
          text-decoration: none;
          font-weight: 400;
          transition: 0.2s ease all;
          border-bottom: 1px solid transparent;
          padding-bottom: 10px;
        }

        &.selected {
          a {
            font-weight: bold;
          }
        }

        &::v-deep {
          &:first-of-type {
            > .parent_container {
              padding-left: 0;
            }

            > .menu__child {
              left: 0;
            }
          }

          .child_indicator {
            path {
              fill: var(--green);
            }
          }
        }
      }
    }

    .ctas {
      grid-column: span 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .phone-icon {
        background: var(--green);
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;

        &:hover {
          background: var(--purple);
          cursor: pointer;
          transition: 0.2s ease all;

          svg {
            path {
              fill: var(--green);
              transition: 0.2s ease all;
            }
          }
        }
      }

      .menu_item__parent {
        @media (max-width: $mobile) {
          display: none;
        }

        &::v-deep {
          div {
            padding-right: 0;
          }

          svg {
            path {
              stroke: var(--green);
            }
          }
        }
      }

      .translation {
        width: 150px;
      }

      .account_login {
        @media (max-width: 1240px) {
          margin-right: 50px;
        }

        @media (max-width: 1024px) {
          display: none;
        }
      }
    }

    .site_button {
      margin: var(--gutter-mobile) 0;
      align-items: center;

      &::v-deep {
        span {
          display: flex;
          line-height: 0px;
        }
      }
    }

    .hamburger {
      grid-column: span 1;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      grid-template-columns: 1fr 1fr;
      column-gap: var(--spacer);
      align-items: center;
      /* margin-top: 2px; */

      &:hover {
        cursor: pointer;
      }

      .site_button {
        grid-column: 1 / span 1;
        width: auto;
      }

      svg {
        width: 32px;
        grid-column: 2 / span 1;
      }
    }
  }

  .mobile-menu-panel {
    position: fixed;
    z-index: 999;
    top: 44px;
    right: 0;
    width: calc(100% - (135px + (var(--spacer) * 2)));
    height: 100%;
    background: var(--green);
    padding: var(--spacer);
    opacity: 0;

    &.scrolled {
      top: 0;
      transition: 0s ease all;
    }

    &.active {
      opacity: 1;
      transition: 0.2s ease all;
    }

    header {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      margin-bottom: 32px;
      padding: 0 0;

      svg {
        &:hover {
          cursor: pointer;
        }

        @media (max-width: $tablet) {
          .admin-bar & {
            margin-top: 32px;
          }
        }

        @media (max-width: $mobile) {
          .admin-bar & {
            margin-top: 46px;
          }
        }
      }
    }

    ul {
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      row-gap: 0;

      &::v-deep {
        li {
          padding: 16px 0;
          border-bottom: 1px solid var(--dark-purple);

          div {
            padding: 0;

            a {
              color: var(--dark-purple);
              font: normal normal normal 18px/24px var(--primary-font-family);

              &:hover {
                color: var(--concrete);
              }
            }
          }

          &.last {
            div {
              padding: 0;
            }
          }
        }
      }
    }

    .ctas {
      grid-column: span 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      margin-top: 40px;

      .menu_item__parent {
        &::v-deep {
          .parent_container {
            padding: 0;
          }

          /* a {
						color: var(--dark-purple);

						&::before {
							background: var(--dark-purple);
						}
					} */

          svg {
            path {
              stroke: var(--dark-purple);
            }
          }
        }
      }

      &::v-deep {
        li {
          padding: 16px 0;

          div {
            padding: 0;

            a {
              color: var(--dark-purple);
              font: normal normal normal 14px/20px var(--primary-font-family);

              &:hover {
                color: var(--concrete);
              }
            }
          }

          &.last {
            div {
              padding: 0;
            }
          }
        }
      }
    }
  }

  .anchored_nav {
    @media (max-width: $tablet) {
      grid-column: span 12;
      margin-left: -16px;
      width: calc(100% + 32px);
    }

    @media (max-width: $mobile) {
      grid-column: span 4;
    }
  }
}

.bounce-enter-active {
  animation: bounce-in 0.15s;
}

.bounce-leave-active {
  animation: bounce-in 0.15s reverse;
}

@keyframes bounce-in {
  0% {
    transform: translateY(-100px);
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}

.slide-fade-horz-enter-active {
  animation: slide-fade-in-horz 0.25s;
}

.slide-fade-horz-leave-active {
  animation: slide-fade-in-horz 0.25s reverse;
}

@keyframes slide-fade-in-horz {
  0% {
    transform: translateX(100px);
    opacity: 0;
  }
  100% {
    transform: translateX(0px);
    opacity: 1;
  }
}

.fade-enter-active {
  animation: fade-in 0.25s;
}

.fade-leave-active {
  animation: fade-in 0.25s reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SiteHeader.vue